export enum DeclarationType {
    Gold = 1,
    Platinum = 2,
    Silver = 3,
    Jewellery = 4,
    AnimalFur = 5,
    Sport = 6,
    Collectible = 7
}